module.exports = __webpack_public_path__ + "img/19.fecede97.jpg";